import React from 'react';
import { withDataProvider, UPDATE } from 'react-admin';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

class ReRunTaskButtonView extends React.Component {
    state = {
        loading: false
    };

    handleClick = () => {
        const { dataProvider, record } = this.props;

        // Prevent multiple clicks
        if (this.state.loading) return;

        this.setState({ loading: true });

        dataProvider(UPDATE, 'tasks', { trailingPath: `reruntask/${record.id}` }, {
            onSuccess: {
                notification: { body: 'Queue task', level: 'info' },
                refresh: true,
                callback: () => this.setState({ loading: false })
            },
            onFailure: {
                notification: { body: 'Error: failed to queue task', level: 'warning' },
                callback: () => this.setState({ loading: false })
            }
        });
    }

    render() {
        const { record } = this.props;
        const { loading } = this.state;

        return record && ((record.statusTypeId > 119 && record.statusTypeId < 200) || record.statusTypeId === 202) ? (
            <Button
                variant="flat"
                onClick={this.handleClick}
                disabled={loading}
            >
                {loading ? <CircularProgress size={20} /> : 'Rerun Task'}
            </Button>
        ) : null;
    }
}

export const ReRunTaskButton = withDataProvider(ReRunTaskButtonView);